import React, { createContext, useContext, useEffect, useState } from "react";

const translations = {
  tr: {
    site_tagline: "Bağımsız haber, anlık dünya.",
    nav_home: "Anasayfa",
    nav_marketplace: "Geliştirici API",
    nav_docs: "Dokümantasyon",
    cta_get_api: "API Al",
    most_read: "En Çok Okunanlar",
    latest: "Son Haberler",
    read_more: "Devamını Oku",
    source: "Kaynak",
    published: "Yayınlandı",
    by_source: "kaynak",
    search_placeholder: "Haberlerde ara...",
    search_results: "Arama Sonuçları",
    no_results: "Sonuç bulunamadı.",
    loading: "Yükleniyor...",
    view_all: "Tümünü Gör",
    breaking: "SON DAKİKA",
    trending: "TREND",
    minutes_ago: "dakika önce",
    hours_ago: "saat önce",
    days_ago: "gün önce",
    just_now: "Az önce",
    footer_about: "loft.press, küresel ve yerel haberleri tek çatı altında toplayan bağımsız bir haber portalıdır.",
    footer_categories: "Kategoriler",
    footer_developers: "Geliştiriciler",
    footer_company: "Şirket",
    footer_legal: "Yasal",
    footer_about_us: "Hakkımızda",
    footer_contact: "İletişim",
    footer_careers: "Kariyer",
    footer_privacy: "Gizlilik",
    footer_terms: "Kullanım Koşulları",
    footer_cookies: "Çerezler",
    newsletter_title: "Günlük bültenimize abone ol",
    newsletter_desc: "Editörlerin seçtiği en önemli haberler her sabah e-postanda.",
    newsletter_placeholder: "e-posta adresiniz",
    newsletter_submit: "Abone Ol",
    newsletter_success: "Abone olundu!",
    // Marketplace
    market_hero_eyebrow: "İÇERİK ÜRETİM API'Sİ",
    market_hero_title: "Özgün içerikler tek bir API ile.",
    market_hero_desc: "Operatör tarafından belirlenen konu ve başlıklardan yapay zekâ destekli olarak oluşturulan, otomatik güvenlik kontrollerinden ve manuel editoryal incelemeden geçen Türkçe ve İngilizce içeriklere API üzerinden erişin.",
    market_hero_desc_2: "Loft Press API; metin, görsel, ses ve video formatlarında yeni içerikler sunabilir. Her içerik Loft Press'in kendi üretim sürecinde oluşturulur ve yalnızca onaylandıktan sonra API üzerinden yayınlanır.",
    market_source_note: "Ücretli API, üçüncü taraf yayıncı içeriklerini, RSS akışlarını veya haricî haber API verilerini müşterilere yeniden sunmaz.",
    market_portal_note: "Loft Press'in halka açık editoryal haber portalı ile ücretli içerik üretim API'si ayrı hizmetlerdir. Halka açık portalda görüntülenen üçüncü taraf kaynaklı içerikler ücretli API paketlerine dahil değildir.",
    market_cta_start: "Ücretsiz Başla",
    market_cta_docs: "Dokümantasyon",
    market_pricing_title: "İhtiyacınıza uygun API erişim planını seçin",
    market_pricing_desc: "Planlar, Loft Press tarafından oluşturulan ve editoryal olarak onaylanan içeriklere API üzerinden erişim sağlar.",
    market_per_month: "/ay",
    market_form_title: "API Anahtarınızı Oluşturun",
    market_form_desc: "Loft Press tarafından oluşturulan ve editoryal olarak onaylanan içeriklere erişmek için kişisel API anahtarınızı oluşturun.",
    custom_title: "İstediğin tutarda kullanım birimi satın al",
    custom_desc: "Loft Press Content Production API'de kullanmak üzere dilediğin tutarda ön ödemeli API kullanım birimi satın al. Seçtiğin tutara karşılık gelen kullanım birimleri, ekranda gösterilen dönüşüm oranına göre hesabına otomatik olarak eklenir.",
    custom_amount_label: "Tutar",
    custom_email_label: "E-posta (opsiyonel)",
    custom_pay_btn: "Şimdi Öde",
    custom_min_max: "Minimum $1 — Maksimum $10.000",
    custom_loading: "Hazırlanıyor...",
    form_name: "Ad Soyad",
    form_email: "E-posta",
    form_company: "Şirket (opsiyonel)",
    form_plan: "Plan",
    form_use_case: "Kullanım amacı",
    form_submit: "Anahtarı Al",
    form_sent: "Anahtar oluşturuldu!",
    credits_word: "API kullanım birimi",
    credits_short: "birim",
    // Docs
    docs_title: "API Dokümantasyonu",
    docs_intro: "Loft Press tarafından oluşturulan ve editoryal olarak onaylanan içeriklere REST API üzerinden erişin.",
    docs_backward_note: "/v1/news, mevcut entegrasyonlarla geriye dönük uyumluluk amacıyla korunan endpoint adıdır. Ücretli API anahtarıyla yapılan isteklerde yalnızca Loft Press tarafından oluşturulan ve editoryal olarak onaylanan içerikler döndürülür.",
    docs_auth_desc: "Ücretli API içeriklerine erişmek için Loft Press hesabınızdan oluşturulan API anahtarını Bearer token olarak gönderin.",
    base_url: "Temel URL",
    endpoints: "Uç Noktalar",
    examples: "Örnekler",
    // Footer new pages
    footer_faq: "SSS",
    footer_changelog: "Değişiklikler",
    footer_status: "Durum",
    footer_tagline: "Ücretli API, Loft Press tarafından oluşturulan ve editoryal olarak onaylanan özgün içeriklere erişim sağlar.",
  },
  en: {
    site_tagline: "Independent newsroom, real-time world.",
    nav_home: "Home",
    nav_marketplace: "Developer API",
    nav_docs: "Docs",
    cta_get_api: "Get API",
    most_read: "Most Read",
    latest: "Latest News",
    read_more: "Read More",
    source: "Source",
    published: "Published",
    by_source: "via",
    search_placeholder: "Search news...",
    search_results: "Search Results",
    no_results: "No results found.",
    loading: "Loading...",
    view_all: "View All",
    breaking: "BREAKING",
    trending: "TRENDING",
    minutes_ago: "min ago",
    hours_ago: "h ago",
    days_ago: "d ago",
    just_now: "Just now",
    footer_about: "loft.press is an independent news portal bringing global and local stories together under one roof.",
    footer_categories: "Categories",
    footer_developers: "Developers",
    footer_company: "Company",
    footer_legal: "Legal",
    footer_about_us: "About",
    footer_contact: "Contact",
    footer_careers: "Careers",
    footer_privacy: "Privacy",
    footer_terms: "Terms",
    footer_cookies: "Cookies",
    newsletter_title: "Subscribe to our daily briefing",
    newsletter_desc: "Editors' picks delivered to your inbox every morning.",
    newsletter_placeholder: "your email address",
    newsletter_submit: "Subscribe",
    newsletter_success: "Subscribed!",
    market_hero_eyebrow: "CONTENT GENERATION API",
    market_hero_title: "Original content through one API.",
    market_hero_desc: "Access Turkish and English content created through AI-assisted workflows from operator-selected topics and titles, processed through automated safety controls and manually reviewed before API publication.",
    market_hero_desc_2: "The Loft Press API may provide newly generated content in text, image, audio and video formats. Every item is created through Loft Press's own production workflow and published through the API only after approval.",
    market_source_note: "The paid API does not redistribute third-party publisher content, RSS feeds or external news API data.",
    market_portal_note: "The Loft Press public editorial news portal and the paid content-generation API are separate services. Third-party sourced content displayed on the public portal is not included in the paid API plans.",
    market_cta_start: "Start Free",
    market_cta_docs: "Read Docs",
    market_pricing_title: "Choose the API access plan that fits your needs",
    market_pricing_desc: "Plans provide API access to content created and editorially approved by Loft Press.",
    market_per_month: "/mo",
    market_form_title: "Generate your API key",
    market_form_desc: "Generate your personal API key to access content created and editorially approved by Loft Press.",
    custom_title: "Purchase usage units in any amount",
    custom_desc: "Purchase prepaid API usage units in the amount you choose for use with the Loft Press Content Production API. The corresponding usage units are automatically added to your account based on the conversion rate displayed on this page.",
    custom_amount_label: "Amount",
    custom_email_label: "Email (optional)",
    custom_pay_btn: "Pay Now",
    custom_min_max: "Minimum $1 — Maximum $10,000",
    custom_loading: "Preparing...",
    form_name: "Full name",
    form_email: "Email",
    form_company: "Company (optional)",
    form_plan: "Plan",
    form_use_case: "Use case",
    form_submit: "Generate Key",
    form_sent: "Key generated!",
    credits_word: "API usage units",
    credits_short: "units",
    docs_title: "API Documentation",
    docs_intro: "Access content created and editorially approved by Loft Press through the REST API.",
    docs_backward_note: "/v1/news is retained for backward compatibility with existing integrations. Requests authenticated with a paid Loft Press API key return only content created and editorially approved by Loft Press.",
    docs_auth_desc: "To access paid API content, send the API key generated from your Loft Press account as a Bearer token.",
    base_url: "Base URL",
    endpoints: "Endpoints",
    examples: "Examples",
    footer_faq: "FAQ",
    footer_changelog: "Changelog",
    footer_status: "Status",
    footer_tagline: "The paid API provides access to original content created and editorially approved by Loft Press.",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("loft_lang") : null;
    return stored === "en" ? "en" : "tr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("loft_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = (key) => translations[lang][key] ?? translations.tr[key] ?? key;

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}

export function formatRelativeTime(iso, lang) {
  if (!iso) return "";
  const t = translations[lang] || translations.tr;
  const date = new Date(iso);
  const diff = (Date.now() - date.getTime()) / 1000;
  if (diff < 60) return t.just_now;
  if (diff < 3600) return `${Math.floor(diff / 60)} ${t.minutes_ago}`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} ${t.hours_ago}`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)} ${t.days_ago}`;
  return date.toLocaleDateString(lang === "tr" ? "tr-TR" : "en-US", { day: "numeric", month: "short" });
}

export function categoryName(category, lang) {
  const map = {
    gundem: { tr: "Gündem", en: "Breaking" },
    ekonomi: { tr: "Ekonomi", en: "Economy" },
    spor: { tr: "Spor", en: "Sports" },
    teknoloji: { tr: "Teknoloji", en: "Technology" },
    dunya: { tr: "Dünya", en: "World" },
    saglik: { tr: "Sağlık", en: "Health" },
  };
  return map[category]?.[lang] || category;
}
